import { SvgBase } from "../svg.base";

export const Down = () => (
  <SvgBase
    width="16"
    height="23"
    viewBox="0 0 16 23"
  >
    <path
      fill="#FFF"
      fillRule="nonzero"
      d="M13.878 13.8a1.112 1.112 0 0 1 1.587 0 1.14 1.14 0 0 1 0 1.586l-6.65 6.651a1.14 1.14 0 0 1-.809.333c-.317 0-.603-.127-.81-.333l-6.65-6.65a1.112 1.112 0 0 1 0-1.588 1.112 1.112 0 0 1 1.587 0l4.746 4.762V1.656A1.116 1.116 0 0 1 8.005.546c.62 0 1.111.491 1.111 1.11V18.56l4.762-4.76z"
    />
  </SvgBase>
);